import React from 'react';
import styled from 'styled-components';
const Icon = styled.svg`
  width: 25px;
  height: 25px;
`;
export default (() => /*#__PURE__*/React.createElement(Icon, {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.5,12.16a2.15,2.15,0,0,1-2,2.34h-.71a2.17,2.17,0,0,1-2.33-2,1.93,1.93,0,0,1,0-.34v-.32a2.16,2.16,0,0,1,2-2.34h.67a2.16,2.16,0,0,1,2.37,1.93,2.81,2.81,0,0,1,0,.41Z",
  fill: "none",
  stroke: "#101010",
  strokeWidth: "1.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13,4l.4,2.33a4.54,4.54,0,0,1,2.83,1.5l1.9-.63L19,8.85l-1.62,1.59a9.39,9.39,0,0,1,.1,1.19v.74a10.2,10.2,0,0,1-.1,1.23L19,15.17l-.9,1.66-1.93-.59a4.61,4.61,0,0,1-2.81,1.46L13,20H11.07l-.45-2.33A4.66,4.66,0,0,1,7.83,16.2l-1.93.59L5,15.12l1.66-1.53a8.25,8.25,0,0,1-.09-1.22v-.74a8.48,8.48,0,0,1,.09-1.23L5,8.8l.88-1.65,1.92.65a4.6,4.6,0,0,1,2.8-1.47L11.07,4H13m1.26-1.5H9.83L9.6,3.72,9.34,5.09a6.25,6.25,0,0,0-1.87,1L6.39,5.73l-1.2-.41-.6,1.12L3.71,8.09l-.53,1,.8.79L5.09,11c0,.23,0,.45,0,.67v.74c0,.21,0,.42,0,.63L4,14l-.85.79.55,1,.9,1.67.58,1.08,1.18-.36,1.1-.33a6.27,6.27,0,0,0,1.89,1l.27,1.38.23,1.22h4.38l.22-1.24.23-1.32a6.26,6.26,0,0,0,1.89-1l1.11.33,1.17.36.59-1.08.9-1.66.55-1-.84-.8L18.92,13c0-.2,0-.41,0-.62v-.77q0-.32,0-.63L20,9.92l.81-.79-.54-1L19.4,6.49l-.6-1.11-1.19.4-1.05.34a6,6,0,0,0-1.9-1l-.23-1.35L14.21,2.5Z"
})));